import React from 'react';
import './About.css';
import sewingImg from './Assets/sewing.jpg';

export default function About() {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-image">
          <img src={sewingImg} alt="Expert seamstress at work" />
        </div>
        <div className="about-content">
          <h2>About K-Alterations</h2>
          <div className="about-divider"></div>
          <p className="about-intro">
            Family-owned with over 10 years of service in Janesville, K-Alterations is owned by Chae, who brings more than 20 years of expert tailoring and alteration experience. We are dedicated to providing the right fit for every garment.
          </p>
          <p>
            Whether you need a wedding dress hemmed, a suit jacket
            tailored for that important meeting, or everyday clothing adjusted for
            comfort, our skilled seamstresses deliver exceptional quality and
            attention to detail.
          </p>
          <p>
            We believe that well-fitted clothing not only looks better but makes
            you feel confident and comfortable. That's why we take the time to
            understand your needs and deliver results that exceed expectations.
          </p>
          <p> Walk-In consultation. No appointment needed.</p>
          <div className="about-features">
            <div className="feature">
              <i className="fas fa-cut"></i>
              <span>Expert Tailoring</span>
            </div>
            
           
            <div className="feature">
              <i className="fas fa-door-open"></i>
              <span>Walk-In Consultation</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
